import React, { ForwardedRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';

import * as echarts from 'echarts';
import { EChartsType } from 'echarts';
import { ChartProps, ChartRef } from './_config/interface';
import { xAxisIntervalFormat } from './_config/plug';

const ChartInner: React.ForwardRefRenderFunction<ChartRef, ChartProps> = (
  { option, hasDataZoom, chartEventConfig, notMerge = true },
  ref: ForwardedRef<ChartRef>
) => {

  const cRef = useRef<HTMLDivElement>(null);
  const cInstance = useRef<EChartsType>();
  const [cache, setCache] = useState('')
  // 初始化注册组件，监听 cRef 和 option 变化
  useEffect(() => {
    // 减少 不必要渲染
    if (cache === JSON.stringify(option)) {
      return
    }
    setCache(JSON.stringify(option))
    if (cRef.current) {
      // 校验 Dom 节点上是否已经挂载了 ECharts 实例，只有未挂载时才初始化
      cInstance.current = echarts.getInstanceByDom(cRef.current);
      if (!cInstance.current) {
        cInstance.current = echarts.init(cRef.current, undefined, {
          renderer: 'canvas',
        });
        if (hasDataZoom && cInstance.current) {
          option = xAxisIntervalFormat(option, {
            formatter: (value: any) => {
              return value ? value?.slice(11, 16) : ''
            },
            chart: cInstance.current
          })
        }

        if (chartEventConfig && cInstance.current) {
          option = chartEventConfig(option, cInstance.current)
        }
      }

      // 设置配置项
      if (option) cInstance.current?.setOption(option, notMerge); // 第二个参数notMerge，默认为false，意为合并之前的option
    }
  }, [cRef, option]);

  // 监听窗口大小变化重绘
  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, [option]);

  // 重新适配大小并开启过渡动画
  const resize = () => {
    cInstance.current?.resize({
      animation: { duration: 300 }
    });
  }

  // 获取实例
  const instance = () => {
    return cInstance.current;
  }

  // 对父组件暴露的方法
  useImperativeHandle(ref, () => ({
    instance
  }));


  return (
    <div ref={cRef} style={{ width: '100%', height: '100%' }} />
  );
};

const Chart = React.forwardRef(ChartInner);

export default Chart;
